import { useState } from 'react';
import { exportClearanceReportToExcel } from './clearanceReportExcelExport';
import { exportClearanceReportToPdf } from './clearanceReportPdfExport';

export const useClearanceReportExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportError, setExportError] = useState(null);

  const exportData = async (data, filename, format, translations, statistics) => {
    if (!data || data.length === 0) {
      setExportError('No data to export');
      return { success: false, error: 'No data to export' };
    }

    setIsExporting(true);
    setExportError(null);

    try {
      let result;
      if (format === 'excel') {
        result = await exportClearanceReportToExcel(data, filename, translations, statistics);
      } else if (format === 'pdf') {
        result = await exportClearanceReportToPdf(data, filename, translations, statistics);
      } else {
        throw new Error('Invalid export format');
      }

      if (!result.success) {
        setExportError(result.error);
      }

      return result;
    } catch (error) {
      setExportError(error.message);
      return { success: false, error: error.message };
    } finally {
      setIsExporting(false);
    }
  };

  const clearError = () => setExportError(null);

  return {
    exportData,
    isExporting,
    exportError,
    clearError,
  };
};
